import { Divider, Drawer, Input, Space, Button, Checkbox } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import { useSession } from "../../../utils/Session";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import { PicRightOutlined, PicLeftOutlined, ArrowUpOutlined, PicCenterOutlined } from '@ant-design/icons';
import MobileSelector from "../../UI/MobileSelector";
import { tt_name_block_warning } from "../../../utils/Utils";

export default function ButtonTop(props) {
    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, view = "desktop", setView = () => { }, id = 0 } = props;
    const [content, setContent] = useState(props.content);
    const [session,] = useSession();
    const [mobile, setMobile] = useState(false);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        data = {},
        container = true,
        date_changed = 0
    } = content;

    // Component specific
    const {
        label = "Scroll to Top",
        align = "right",
        type = 0,
        arrow = false,

        allow_mobile_overrides = false,
        mobile_arrow = false,
        mobile_hide = false,

    } = data;

    const save = () => {
        if(!name){
            let _name = prompt(tt_name_block_warning);
            if(_name){
                close();
                saveItem(id, { ...content, "name" : _name });
            } else {
                return; 
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const drawRender = () => {

        const _style = {
            textAlign: align,
            zIndex: "10",
            position: session.is_editing === false ?  "fixed" : "initial",
            right: align === "right" ? "100px": "0",
            bottom: "50px",
            left: align === "left" ? "100px" : "0",
            display: (allow_mobile_overrides && view !== "desktop" && mobile_hide) ? "none" : "initial",
        }

        return (
            <div id={"bm-" + id} style={{textAlign: align}}>
                <div style={_style}>
                    <Button className={"bm-btn-" + type}>
                        {(
                            arrow ||
                            (allow_mobile_overrides && view !== "desktop" && mobile_arrow)
                        )
                            ? <ArrowUpOutlined />
                            : label
                        }
                    </Button>                
                </div>
            </div>
        )
    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading hide_container={true} menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                <MobileSelector setView={setView} onChange={(e) => setMobile(e)} />
                <div className="shim" /><div className="shim" />
                {(mobile && drawMobile())}
                {(!mobile && drawDesktop())}
            </>
        )
    }

    const drawMobile = () => {
        return (
            <>
                <div>
                    <Checkbox onChange={(e) => setData({ ...data, "allow_mobile_overrides": e.target.checked })} checked={allow_mobile_overrides}><small>Enable Overides?</small></Checkbox>
                    <div className="shim" /><div className="shim" />

                    {/* ARROW */}
                    <Checkbox disabled={!allow_mobile_overrides} checked={mobile_arrow} onChange={(e) => setData({ ...data, "mobile_arrow": e.target.checked })} ><small>Arrow?</small></Checkbox>
                    <div className="shim" /> <div className="shim" />

                    
                    {/* HIDE BUTTON */}
                    <Checkbox disabled={!allow_mobile_overrides} checked={mobile_hide} onChange={(e) => setData({ ...data, "mobile_hide": e.target.checked })} ><small>Hide Button?</small></Checkbox>
                    <div className="shim" /> <div className="shim" />
                </div>
            </>
        )
    }

        const drawDesktop = () => {
        return (
            <>
                <div>
                    {/* LABEL */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LABEL</Divider>
                    <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "label": e.target.value })} value={label} placeholder="Label..." />
                    <div className="shim" /> <div className="shim" />


                    <Checkbox checked={arrow} onChange={(e) => setData({ ...data, "arrow": e.target.checked })} ><small>Arrow?</small></Checkbox>
                    <div className="shim" /> <div className="shim" />
                    
                    {/* BUTTON PRESET */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PRESET</Divider>
                    <ButtonPicker value={type} onChange={(e) => setData({ ...data, "type": e })} />
                    <div className="shim" /> <div className="shim" />

                    {/* ALIGN */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN</Divider>
                    <div className="float-flex">
                        <Space>
                            <div><PicLeftOutlined onClick={() => setData({ ...data, "align": "left" })} style={{ "color": (align === "left") ? "#1890ff" : "#AAA" }} /></div>
                            <div><PicCenterOutlined onClick={() => setData({ ...data, "align": "center" })} style={{ "color": (align === "center") ? "#1890ff" : "#AAA" }} /></div>
                            <div><PicRightOutlined onClick={() => setData({ ...data, "align": "right" })} style={{ "color": (align === "right") ? "#1890ff" : "#AAA" }} /></div>
                        </Space>
                    </div>
                    <div className="shim" /> <div className="shim" />
                </div>
            </>
        )
    }



    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX" : "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}